import {callApi} from '@/lib/api/callApi';

/**
 * 取得通知
 * @param {Object} params 參數
 * @returns {Promise} promise
 *
 */
async function getNotifications(params) {
  const res = await callApi({
    category: 'notification',
    apiName: '',
    method: 'get',
    params,
  });
  return res.data;
}

/**
 * 更新通知
 * @param {String} id 參數
 * @param {Object} data 參數
 * @returns {Promise} promise
 *
 */
async function updateNotifications(id, data) {
  const res = await callApi({
    category: 'notification',
    apiName: `${id}`,
    method: 'patch',
    data,
    defaultError: '更新通知失败',
  });
  return res.data;
}

export default {
  getNotifications,
  updateNotifications,
};
